import styled from 'styled-components';

import { PrimaryButton } from 'styles/common';
import { colorPrimaryLight, colorWhite, mediaMd, mediaSm, mediaTablet } from 'theme/theme-helper-selectors';

export const Container = styled.div`
    position: relative;
    z-index: 10;
    padding: 0 0 80px;
    background: linear-gradient(0deg, transparent, rgba(0, 168, 142, 0.1) 30%) no-repeat;

    @media (${mediaMd}) {
        padding: 0;
    }
`;

export const CarouselContainer = styled.div`
    overflow: hidden;
`;

export const CarouselItem = styled.div`
    position: relative;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 480px;
    outline: none;

    @media (max-width: 1023px) {
        min-height: 320px;
    }

    @media (max-width: 767px) {
        min-height: 280px;
    }
`;

export const ItemImage = styled.img<{ $isCompass: boolean }>`
    width: 100%;
    max-width: 140px;
    height: auto;
    aspect-ratio: 1;
    margin: 0 auto 20px;
    pointer-events: none;
    object-fit: contain;
    transform-origin: center;
    transition: transform 1.25s ease;

    @media (${mediaTablet}) {
        max-width: 200px;
    }

    @media (min-width: 768px) and (max-width: 1023px) {
        max-width: 140px;
    }

    .slick-center & {
        transform: scale(${({ $isCompass }) => ($isCompass ? 1.2 : 1.8)});

        @media (min-width: 1024px) {
            transform: scale(${({ $isCompass }) => ($isCompass ? 1.4 : 2.16)});
        }
    }
`;

export const ItemText = styled.p`
    position: absolute;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    width: max-content;
    max-width: calc(100% - 24px);
    margin: 0;
    padding: 8px 26px;
    color: ${colorWhite};
    font-size: 19px;
    line-height: 16px;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 26px;
    opacity: 0.9;
    transform: translate(-50%, -50%);

    @media (${mediaSm}) {
        max-width: calc(100% - 16px);
        padding: 6px 12px;
        font-size: 16px;
        line-height: 17px;
    }
`;

export const OpenedTitle = styled.h2`
    position: relative;
    margin: 0 0 70px;
    font-size: 96px;
    font-weight: 500;
    line-height: 96px;

    @media (${mediaMd}) {
        margin: 0 0 20px;
        font-size: 56px;
        line-height: 56px;
    }

    @media (${mediaSm}) {
        font-size: 32px;
        line-height: 32px;
    }
`;

export const Bubble1 = styled.img`
    position: absolute;
    top: 70px;
    left: 0;

    @media (${mediaMd}) {
        top: 10px;
        left: 38%;
        width: 54px;
    }
`;

export const Bubble2 = styled.img`
    position: absolute;
    top: 350px;
    left: 0;
    z-index: -1;

    @media (${mediaMd}) {
        top: 580px;
        left: -40px;
        width: 150px;
    }
`;

export const Bubble3 = styled.img<{ isClosed: boolean }>`
    position: absolute;
    top: 480px;
    left: 29%;
    z-index: -1;

    @media (${mediaMd}) {
        top: ${({ isClosed }) => (isClosed ? '310px' : '210px')};
        right: -90px;
        left: auto;
        width: 210px;
    }
`;

export const Bubble4 = styled.img`
    position: absolute;
    top: 180px;
    right: 0;

    @media (${mediaMd}) {
        top: 0;
        width: 80px;
    }
`;

export const ActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 30px;

    @media (${mediaSm}) {
        gap: 20px;

        ${PrimaryButton} {
            padding: 14px 24px;
            background: ${colorWhite};
        }
    }
`;

export const DateContainer = styled.p`
    font-size: 21px;
    font-weight: 600;
    line-height: 24px;

    @media (${mediaSm}) {
        font-size: 18px;
        line-height: 21px;
    }
`;

export const DateContainerClosed = styled.h2`
    max-width: 1000px;
    margin: 25px 0;
    font-size: 70px;
    font-weight: 500;
    line-height: 70px;

    @media (${mediaMd}) {
        margin: 20px 0;
        font-size: 56px;
        line-height: 56px;
    }

    @media (${mediaSm}) {
        font-size: 32px;
        line-height: 32px;
    }
`;

export const CloseBlock = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 70px 0;

    @media (${mediaMd}) {
        margin: 36px 0;
    }
`;

export const Closed = styled.div`
    padding: 6px 16px;
    font-size: 24px;
    font-weight: 500;
    border: 1px solid ${colorPrimaryLight};
    border-radius: 56px;

    @media (${mediaSm}) {
        height: 30px;
        font-size: 17px;

        ${PrimaryButton} {
            padding: 14px 24px;
        }
    }
`;
